import { defineComponent as _defineComponent } from 'vue'
import VTextField from "@busy-human/vue-component-library/components/text-field.vue"
import PaymentMethod from "./payment-method.vue"
import useClickOutside from '../composables/useClickOutside'
import { PaymentMethods, FinancialUserspaces, DataInstance } from '@busy-human/opt-library'
import { ref } from 'vue';
import { useBalance } from "@/util/balance";

type Props = {
    price: number
    dontClose: boolean
    userFinancial: DataInstance<FinancialUserspaces.Model>
    paymentMethods: DataInstance<PaymentMethods.Model>[]
    withdraw?: boolean

}
type Emits = {
    (e: 'close'): void
    (e: 'addPaymentMethod'): void
    (e: "useBalance"): void,
    (e: "selectInfo", value: DataInstance<PaymentMethods.Model>): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'payment-select-window',
  props: {
    price: null,
    dontClose: { type: Boolean },
    userFinancial: null,
    paymentMethods: null,
    withdraw: { type: Boolean }
  },
  emits: ["close", "addPaymentMethod", "useBalance", "selectInfo"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'close'): void
    (e: 'addPaymentMethod'): void
    (e: "useBalance"): void,
    (e: "selectInfo", value: DataInstance<PaymentMethods.Model>): void,
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    price: number
    dontClose: boolean
    userFinancial: DataInstance<FinancialUserspaces.Model>
    paymentMethods: DataInstance<PaymentMethods.Model>[]
    withdraw?: boolean

}





const paymentSelect = ref()
useClickOutside(paymentSelect, ()=> {
    if(!props.dontClose)
        emit('close')
})

const onUseBalance = () => {
    emit('useBalance')
    emit('close')
}

const selectInfo = (paymentMethod: DataInstance<PaymentMethods.Model>) => {
    emit('selectInfo', paymentMethod)
    emit('close')
}

const addPaymentMethod = () => {
    emit('addPaymentMethod')
}

const balances = useBalance();


const __returned__ = { props, emit, paymentSelect, onUseBalance, selectInfo, addPaymentMethod, balances, VTextField, PaymentMethod, useClickOutside, PaymentMethods, FinancialUserspaces, DataInstance, ref, useBalance }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})